import BaseClient from '@/app/model/api/response/baseApiClient'

class MachineListApi extends BaseClient {
  public getMachineList (data: any) {
    const path = '/v1/machines'
    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params = new URLSearchParams({})

    if (data.word !== '') {
      params.append('word', data.word)
    }
    if (data.order_name !== '') {
      params.append('order_name', data.order_name)
    }
    if (data.sort === false) {
      params.append('sort', 'desc')
    } else {
      params.append('sort', 'asc')
    }
    if (data.machine_type !== null) {
      params.append('machine_type', data.machine_type)
    }
    if (data.is_valid !== null) {
      params.append('is_valid', data.is_valid)
    }

    url.search = params.toString()

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new MachineListApi()
